import { render, staticRenderFns } from "./instSystemScreenDescription.vue?vue&type=template&id=32aab257&scoped=true"
import script from "./instSystemScreenDescription.vue?vue&type=script&lang=js"
export * from "./instSystemScreenDescription.vue?vue&type=script&lang=js"
import style0 from "./instSystemScreenDescription.vue?vue&type=style&index=0&id=32aab257&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aab257",
  null
  
)

export default component.exports